import OptionGroup from '../OptionGroup'
import { finalSummaryHtml } from '../reserveReducer'
import StepShell, { Question } from '../StepShell'
import Field from '../Field'

const TIMELINES = [
  { label: 'ASAP', value: 'ASAP - this week' },
  { label: 'Within 14 days', value: 'Within 14 days' },
  { label: 'This quarter', value: 'This quarter' },
  { label: 'Exploring', value: 'Just exploring' },
]

export default function StepTimeline({ answers, dispatch, active, reportedBurn }) {
  return (
    <StepShell active={active} step={5}>
      <Question>When do you need it live?</Question>
      <Field label="Timeline">
        <OptionGroup
          group="timeline"
          options={TIMELINES}
          value={answers.timeline}
          onSelect={(group, value) => dispatch({ type: 'SET_ANSWER', field: group, value })}
        />
      </Field>
      <div
        className="mt-5 rounded-[11px] border border-[var(--line)] bg-[var(--paper-2)] px-[18px] py-4 font-mono text-[13px] leading-[1.85] text-[var(--ink-2)] [&_b]:font-semibold [&_b]:text-[var(--ink)]"
        dangerouslySetInnerHTML={{ __html: finalSummaryHtml(answers, reportedBurn) }}
      />
    </StepShell>
  )
}
